import { render } from "./AppFooter.vue?vue&type=template&id=fd1c5298&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=fd1c5298&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fd1c5298"

export default script